import $ from 'jquery';

// Sticky header
var el = $( '.c-header' );
var elOffset = el.offset().top;
var scrollTop = $( window ).scrollTop();
var distance = ( elOffset - scrollTop );

if ( scrollTop > distance ) {
	el.addClass( 'c-header--not-top' );
} else {
	el.addClass( 'c-header--top' );
}

$( window ).on('scroll', function( event ){
	var scrollTop = $( this ).scrollTop();

	if ( scrollTop > distance ) {
		el.removeClass( 'c-header--top' ).addClass( 'c-header--not-top' );
	} else {
		el.removeClass( 'c-header--not-top' ).addClass( 'c-header--top' );
	}
})

// Header search
$( '.js-search-toggle' ).on( 'click', function( e ) {
	e.preventDefault();
	$( '.c-header__search' ).toggleClass( 'is-active' );
	$( '.c-header__search input' ).get(0).focus();
} );

$('body').on("keydown", function ( e ) {
	if ( e.key == 'Escape' ) {
		$( '.c-header__search' ).removeClass( 'is-active' );
	}
});

$( document ).on( 'click', function( e ) {
	var container = $(".c-header__search" );
	if ( !container.is( e.target ) && !container.has( e.target ).length ) {
		container.removeClass( 'is-active' );
	}
});
